import React from 'react';
import { Form, Upload, Typography, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';
import { MAX_BUDGET_IMAGES } from './budgetImages';

// Tamaño máximo por imagen (mismo límite que tenía el formulario anterior).
const MAX_MB = 40;

const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);

// Imágenes del presupuesto. Cada imagen se sube al elegirla
// (`upload/file/presupuesto`); el formulario guarda el `fileList` y el drawer
// envía los ids en `images` al crear/editar (ver budgetImages.js).
function BudgetImagesField({ disabled = false, legacyCount = 0 }) {
  const beforeUpload = (file) => {
    if (!file.type?.startsWith('image/')) {
      message.error(`${file.name} no es una imagen`);
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 >= MAX_MB) {
      message.error(`${file.name} pesa más de ${MAX_MB} MB`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const onChange = ({ file }) => {
    if (file.status === 'done' && !file.response?.success) {
      message.error(`No se pudo subir ${file.name}`);
    } else if (file.status === 'error') {
      message.error(`No se pudo subir ${file.name}`);
    }
  };

  return (
    <Form.Item
      name="images"
      label="Imágenes (opcional)"
      valuePropName="fileList"
      getValueFromEvent={normFile}
      extra={
        <>
          Se incluyen en el documento del presupuesto. Hasta {MAX_BUDGET_IMAGES} imágenes.
          {legacyCount > 0 ? (
            <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
              Este presupuesto tiene {legacyCount}{' '}
              {legacyCount === 1
                ? 'imagen anterior que se conserva'
                : 'imágenes anteriores que se conservan'}
              .
            </Typography.Text>
          ) : null}
        </>
      }
    >
      <Upload
        action={`${API_PATH}/upload/file/presupuesto`}
        headers={{ Authorization: getAccessTokenApi() }}
        listType="picture-card"
        accept="image/*"
        multiple
        maxCount={MAX_BUDGET_IMAGES}
        beforeUpload={beforeUpload}
        onChange={onChange}
        disabled={disabled}
      >
        {disabled ? null : (
          <button type="button" style={{ border: 0, background: 'none', cursor: 'pointer' }}>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Agregar imagen</div>
          </button>
        )}
      </Upload>
    </Form.Item>
  );
}

export default BudgetImagesField;
